import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as BetslipActions from 'actions/BetslipActions';
import * as TerminalBetslipActions from 'actions/TerminalBetslipActions';
import * as UiActions from 'actions/UiActions';
import * as TrackingEventActions from 'actions/TrackingEventActions';
import 'css/ViewMainMarkets.scss';
import {
    EVENT_STATUS,
    MARKET_STATUS,
    ANBEFALET_SPORT_ID,
} from 'constants/appConfig';
import { UI_ERROR_MESSAGE } from 'constants/ui';
import tapOrClick from 'utils/click-or-touch';
import ReactTouchEvents from 'react-touch-events';
import { MarketButtonStyled as Button } from '../styled';
import { detectMobile, isTerminal, isActiveBetButton } from 'utils/UiHelper';
import {
    VAIX_TRACKING_LOCATION_FOR_TYPE_OF_SPORT,
    VAIX_TRACKING_TYPE,
} from 'constants/vaix/VaixTrcakingConstants';
import { trackEvents } from '../../../helpers/VaixHelpers/VaixTracking';
import { Col } from '../../../styled';

const MobileButton = ({ item, tapHandler, isActive }) => {
    return (
        <ReactTouchEvents onTap={tapHandler}>
            <Button active={isActive} oddsYellow>
                {item.odds.toFixed(2)}
            </Button>
        </ReactTouchEvents>
    );
};

const DesktopButton = ({ item, clickHandler, isActive }) => {
    return clickHandler ? (
        <Button {...clickHandler} active={isActive} oddsYellow>
            {item.odds.toFixed(2)}
        </Button>
    ) : (
        <Button active={isActive} oddsYellow>
            {item.odds.toFixed(2)}
        </Button>
    );
};

const ViewMainMarketBtnNew = (props) => {
    const { market, item, live: isLive, ev, disabled } = props;
    const path = window.location.pathname;

    const onTrackEvent = () => {
        console.log(
            'onTrackEvent',
            ev.externalId,
            VAIX_TRACKING_TYPE.clickOutcome,
            VAIX_TRACKING_LOCATION_FOR_TYPE_OF_SPORT(ev.sport),
            '/live',
            props.auth?.user?.userId || 0,
            0
        );
        trackEvents(
            ev,
            VAIX_TRACKING_TYPE.clickOutcome,
            VAIX_TRACKING_LOCATION_FOR_TYPE_OF_SPORT(ev.sport),
            '/live',
            props.auth?.user?.userId || 0,
            0,
            ev.vaixIndex
        );
    };

    const onClickHandler = () => {
        if (ev?.vaixIndex > 0) {
            onTrackEvent();
        }

        let widgetType;
        if (
            (path === '/sport/live' || path === '/live') &&
            props.activeSportId === ANBEFALET_SPORT_ID
        ) {
            widgetType =
                'sr-widget:livepagebetrecommendation.eventlist:recommended';
        } else if (/^(\/|\/sport\/?)$/.test(path)) {
            widgetType =
                isLive === 1
                    ? 'sr-widget:livepagebetrecommendation.eventlist:recommended'
                    : 'sr-widget:prematchbetrecommendation.eventlist:recommended';
        }
        if (isLive === 1 && /^(\/|\/sport\/?)$/.test(path)) {
            widgetType =
                'sr-widget:livebetrecommendation.eventlist:recommended';
        }

        if (widgetType) {
            props.trackClickEvent(
                'clicks:outcome',
                `sr:match:${ev?.externalId}`,
                'event_id',
                widgetType,
                path,
                props.auth?.user?.userId || 0
            );
        }

        if (
            props.betslip.customBetEventId !== null ||
            props.betslip.placedCustomBetMarkets.length > 0
        ) {
            props.uiActions.notification(
                UI_ERROR_MESSAGE,
                'Komibinationen er ikke tilladt'
            );
        } else {
            if (!isTerminal()) {
                props.betslipActions.addMarket(
                    market.marketId,
                    item.betNr,
                    item.odds,
                    isLive,
                    market.sportId,
                    props.betslip.hasMarkets
                );
            } else {
                if (props.betslip.betList.length < 15) {
                    if (
                        props.betslip.betList.filter(
                            (b) => b.eventId === market.eventId
                        ).length === 0
                    ) {
                        props.terminalBetslipActions.addMarket(
                            props.betslip,
                            ev.eventId,
                            ev.eventName,
                            market.marketId,
                            item.betNr,
                            0,
                            item.odds,
                            item.bet,
                            market.marketName,
                            ev.live,
                            ev
                        );
                    } else {
                        props.uiActions.notification(
                            UI_ERROR_MESSAGE,
                            'Komibinationen er ikke tilladt'
                        );
                    }
                } else {
                    props.uiActions.betslipLimit();
                }
            }
        }
    };

    const onClickRemoveHandler = () => {
        const marketId = market.marketId;

        if (!isTerminal()) {
            if (props.betslip.betList.length > 1) {
                props.betslipActions.clearSystemMarket(
                    market.eventId,
                    marketId
                );
            } else {
                props.betslipActions.clearSingleMarket(
                    market.eventId,
                    marketId
                );
            }
        } else {
            props.terminalBetslipActions.removeMarket(marketId);
        }
    };

    if (
        market &&
        market.itemList &&
        ev.status === EVENT_STATUS.IN_PROGRESS &&
        market.status === MARKET_STATUS.ACTIVE &&
        (market.marketTypeGroupName === '1X2' || market.itemList.length < 4)
    ) {
        if (item && item.odds > 1) {
            const hasMarkets = props.betslip.hasMarkets;

            if (
                hasMarkets.length === 0 ||
                hasMarkets.indexOf(props.market.marketId) === -1
            ) {
                return (
                    <Col>
                        {!disabled ? (
                            !detectMobile() ? (
                                <DesktopButton
                                    item={item}
                                    clickHandler={tapOrClick(onClickHandler)}
                                />
                            ) : (
                                <MobileButton
                                    item={item}
                                    tapHandler={onClickHandler}
                                />
                            )
                        ) : (
                            <DesktopButton item={item} />
                        )}
                    </Col>
                );
            } else {
                let isOrange = isActiveBetButton(
                    item,
                    props.market,
                    props.betslip.setMarketsNew
                );

                return (
                    <Col>
                        {!disabled &&
                            (!detectMobile() ? (
                                <DesktopButton
                                    item={item}
                                    clickHandler={
                                        isOrange
                                            ? tapOrClick(onClickRemoveHandler)
                                            : tapOrClick(onClickHandler)
                                    }
                                    isActive={isOrange}
                                />
                            ) : (
                                <MobileButton
                                    item={item}
                                    tapHandler={
                                        isOrange
                                            ? onClickRemoveHandler
                                            : onClickHandler
                                    }
                                    isActive={isOrange}
                                />
                            ))}
                    </Col>
                );
            }
        }
    }

    return (
        <Col>
            <Button disabled>{item?.odds?.toFixed(2) || '-'}</Button>
        </Col>
    );
};

const areEqual = (prevProps, nextProps) => {
    if (
        prevProps.market &&
        prevProps.betslip.setMarketsNew.length !==
            nextProps.betslip.setMarketsNew.length
    ) {
        return false;
    }
    if (prevProps.item.odds !== nextProps.item.odds) {
        return false;
    }
    return prevProps.disabled === nextProps.disabled;
};

function mapStateToProps(state) {
    return {
        betslip: state.betslip,
        auth: state.auth,
        activeSportId: state.uiSportLive.activeSportId,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        uiActions: bindActionCreators(UiActions, dispatch),
        betslipActions: bindActionCreators(BetslipActions, dispatch),
        terminalBetslipActions: bindActionCreators(
            TerminalBetslipActions,
            dispatch
        ),
        trackClickEvent: bindActionCreators(
            TrackingEventActions.trackClickEvent,
            dispatch
        ),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(React.memo(ViewMainMarketBtnNew, areEqual));
